import { combineReducers } from "redux";
import languages from "./languages";
import auth from "./auth";
import pageHome from "./page/home";
import pageAbout from "./page/about";
import pageService from "./page/service";
import pageContact from "./page/contact";
import postCategories from "./post/categories";
import postPosts from "./post/posts";
import productBrands from "./product/brands";
import productCategories from "./product/categories";
import productProducts from "./product/products";
import faqs from "./faqs";
import quotes from "./quotes";

export default combineReducers({
  languages,
  auth,
  page: combineReducers({
    home: pageHome,
    about: pageAbout,
    service: pageService,
    contact: pageContact
  }),
  post: combineReducers({
    categories: postCategories,
    posts: postPosts
  }),
  product: combineReducers({
    brands: productBrands,
    categories: productCategories,
    products: productProducts
  }),
  faqs,
  quotes
});



// WEBPACK FOOTER //
// ./src/reducers/index.js